<template>
  <div class="common_not_data">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'NotData'
}
</script>

<style lang="scss" scoped>
.common_not_data { box-sizing: border-box; min-height: 560px; padding-top: 513px; font-size: 20px; font-weight: 400; color: #666; text-align: center; background-image: url(~@/assets/images/bg_not_data.png); background-repeat: no-repeat; background-position: center center; background-size: 438px 338px;
}
</style>
